import { render, staticRenderFns } from "./OperationsFilter.vue?vue&type=template&id=0bcbc70f&"
import script from "./OperationsFilter.vue?vue&type=script&lang=ts&"
export * from "./OperationsFilter.vue?vue&type=script&lang=ts&"
import style0 from "./OperationsFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
